
export { default as CreateExamDetailDescription} from './CreateExamDetailDescription';
export { default as EditExamDetailDescription } from './EditExamDetailDescription';
export { default as ExamDetailDescriptionList } from './ExamDetailDescriptionList';
export { default as Header } from '../Header';
export { default as AdminNavbar } from '../AdminNavbar';
export { default as Adminmain } from '../Adminmain';
